import script from "./ProClenyLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProClenyLogin.vue?vue&type=script&setup=true&lang=ts"

import "./ProClenyLogin.vue?vue&type=style&index=0&id=52995c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52995c3c"]])

export default __exports__